var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Connections")]),_c('BaseCard',[_c('BaseStats',{attrs:{"stats":[
        {
          value: _vm.stats.curr_connections,
          label: 'active connections',
        },
        {
          value: _vm.historicalConnections,
          label: _vm.historicalConnectionsLabel,
        } ]}}),(_vm.issue)?_c('BaseNotice',{staticClass:"connections-notice",attrs:{"type":"warning"}},[_vm._v(" "+_vm._s(_vm.issue)+" ")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }